/**
 * SectionWrapper — 에디터 모드에서 섹션 클릭/하이라이트 래퍼
 *
 * mode === 'viewer'이면 래퍼 없이 children만 렌더링.
 */

import type { ReactNode } from 'react'
import type { SectionId } from '@cugumi/shared/schemas'
import { cn } from '../../../lib/cn.js'
import styles from './SectionWrapper.module.css'

interface SectionWrapperProps {
  sectionId: SectionId
  activeSection?: SectionId | null
  onSectionClick?: (sectionId: SectionId) => void
  mode: 'editor' | 'viewer'
  className?: string
  children: ReactNode
}

export function SectionWrapper({
  sectionId,
  activeSection,
  onSectionClick,
  mode,
  className,
  children,
}: SectionWrapperProps) {
  if (mode === 'viewer') {
    return <div className={className}>{children}</div>
  }

  return (
    <div
      className={cn(styles.clickable, activeSection === sectionId && styles.active, className)}
      onClick={() => onSectionClick?.(sectionId)}
      role="button"
      tabIndex={0}
    >
      {children}
    </div>
  )
}
